

























import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ValidationModel } from '@/types/models/validation';
import { BrowserLocale, DateFormat } from '@/types';

export default Vue.extend({
  name: 'MStoreFormDatePicker',
  mixins: [FormFieldValidation],
  props: {
    value: {
      required: true
    },
    placeholder: String,
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object as () => ValidationModel,
      default: () => ({} as ValidationModel)
    },
    id: {
      type: String,
      required: true
    },
    name: String,
    readonly: Boolean,
    isDisabled: Boolean,
    format: String,
    lang: String,
    valueType: {
      type: String,
      default: 'date'
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        if (this.value && this.valueType === 'format') {
          return this.convertDate(this.value, DateFormat.UK, this.displayFormat, BrowserLocale.UK);
        }
        return this.value;
      },
      set(this: any, newValue: string) {
        let formattedValue = null;
        if (newValue) {
          if (this.valueType === 'format') {
            formattedValue = this.convertDate(newValue, this.displayFormat, DateFormat.UK);
          } else {
            formattedValue = this.convertDate(newValue, this.displayFormat, DateFormat.IsoFormat);
          }
        }
        this.$emit('input', formattedValue);
      }
    },
    displayFormat(this: any) {
      return this.format || (window.navigator.language.toLowerCase() === BrowserLocale.US ? DateFormat.US : DateFormat.UK);
    },
    language(this: any) {
      return this.lang || window.navigator.language;
    },
    inputPlaceholder(this: any) {
      return this.size === 'sm' ? this.label : this.placeholder || this.displayFormat.toLowerCase();
    },
    sizeAdjustedLabel(this: any) {
      return this.size === 'sm' ? '' : this.label;
    }
  },
  methods: {
    convertDate(this: any, value: string, fromFormat: string, targetFormat: string, locale: string) {
      const date = moment(value, fromFormat)
        .locale(locale || this.language)
        .format(targetFormat);
      return date;
    }
  },
  components: {
    DatePicker
  }
});
